



































import {Component, Vue} from 'vue-property-decorator'
import UserInfo from '@/components/layout/standard/UserInfo.vue'

@Component({
  components: {UserInfo}
})
export default class Header extends Vue {
}
